import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    invitationId: z.string(),
  }),
  response: z.object({
    url: z.string(),
  }),
};
